import ActionTypes from '../constants/ActionTypes';

const initialState = {
  query: '',
  products: [],
  isSubmitting: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.PRODUCTS_FETCH:
      return {
        ...initialState,
        query: payload.query,
        isSubmitting: true,
      };
    case ActionTypes.PRODUCTS_FETCH__SUCCESS:
      return {
        ...state,
        ...payload,
        query: state.query,
        isSubmitting: false,
      };
    case ActionTypes.PRODUCTS_FETCH__FAILURE:
      return {
        ...state,
        isSubmitting: false,
      };
    default:
      return state;
  }
};
